import React from 'react';
import styled from 'styled-components';
import { Heart, Shield, Phone, Mail, MapPin } from 'lucide-react';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
  color: white;
  padding: 32px 24px 24px;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 32px;
  margin-bottom: 24px;
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FooterTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const FooterText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  opacity: 0.9;
`;

const FooterLink = styled.a`
  color: white;
  text-decoration: none;
  font-size: 14px;
  opacity: 0.9;
  transition: opacity 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    opacity: 1;
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

const Copyright = styled.div`
  font-size: 14px;
  opacity: 0.8;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterTitle>
            <Heart size={20} />
            About CHCA
          </FooterTitle>
          <FooterText>
            Community Health Centers of America is dedicated to providing 
            comprehensive healthcare services and improving patient outcomes 
            through innovative tools like the LACE assessment system.
          </FooterText>
        </FooterSection>

        <FooterSection>
          <FooterTitle>
            <Shield size={20} />
            LACE Tool
          </FooterTitle>
          <FooterText>
            The LACE Tool helps healthcare providers assess patient readmission 
            risk by evaluating Length of stay, Acuity of admission, 
            Comorbidities, and Emergency visits.
          </FooterText>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Contact Information</FooterTitle>
          <FooterLink href="tel:+1209-441-8383">
            <Phone size={16} />
            209-441-8383
          </FooterLink>
          <FooterLink href="mailto:info@chcahealth.org">
            <Mail size={16} />
            info@chcahealth.org
          </FooterLink>
          <FooterLink href="#">
            <MapPin size={16} />
            5200 Pirrone Ct, Salida, CA 95368
          </FooterLink>
        </FooterSection>
      </FooterContent>

      <FooterBottom>
        <Copyright>
          © 2025 Community Health Centers of America. All rights reserved.
        </Copyright>
        <FooterLinks>
          <FooterLink href="https://www.chcahealth.org/privacy-policy/">Privacy Policy</FooterLink>
          <FooterLink href="https://www.chcahealth.org/terms-and-conditions/">Terms of Service</FooterLink>
          <FooterLink href="#">Support</FooterLink>
        </FooterLinks>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
